import _objectWithoutProperties from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["headerData", "footerData", "blocks"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import Layout from '@ratehub/web-server/src/components/Layout';
import BlockRenderer from '@ratehub/web-server/src/components/BlockRenderer';
import BaseBlockMap from '@ratehub/web-server/src/definitions/BaseBlockMap';
import CorporateBlockMap from '@ratehub/web-server/src/definitions/CorporateBlockMap';
import InsuranceBlockMap from '@ratehub/web-server/src/definitions/InsuranceBlockMap';
import { WP_PAGE_PROP_TYPES, DEFAULT_WP_PAGE_PROPS } from '../definitions/RHInsWordpressPagePropTypes';
import { jsx as _jsx } from "react/jsx-runtime";

var BLOCK_MAP = _objectSpread(_objectSpread(_objectSpread({}, BaseBlockMap), CorporateBlockMap), InsuranceBlockMap);

function DefaultPage(_ref) {
  var headerData = _ref.headerData,
      footerData = _ref.footerData,
      blocks = _ref.blocks,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Layout, _objectSpread(_objectSpread({
    headerData: headerData,
    footerData: footerData,
    disableAccounts: true
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsx(BlockRenderer, {
      blocks: blocks,
      blockMap: BLOCK_MAP
    })
  }));
}

DefaultPage.defaultProps = _objectSpread({}, DEFAULT_WP_PAGE_PROPS);
export default DefaultPage;